import Mark from "./vendors/mark";
const searchHighlight = {
    init() {
        const searchContainer = $('.search-results');
        const searchTerm = $('.js-search-term').data('term');



        if(searchContainer[0]) {

            var context = document.querySelector(".search-posts-grid");
            var instance = new Mark(context);
            instance.mark(searchTerm);


        }



    }
}

export {searchHighlight}